const fa = {
  Hi: "سلام",
  Description: "کمک خواستن؟\n لطفا اسناد ما را بررسی کنید.",
  Documentation: "مستندات",
  EnglishLevel: "سطح زبان انگلیسی",
  FrenchLevel: "سطح زبان فرانسوی",
  EnglishExam: "امتحان زبان انگلیسی",
  FrenchExam: "امتحان فرانسه",
  ExamType: "نوع امتحان",
  Score: "نمره",
  ReadingScore: "امتیاز خواندن",
  WritingScore: "نمره Writing",
  ListeningScore: "امتیاز گوش دادن",
  SpeakingScore: "نمره صحبت کردن",
  ExamDate: "تاریخ امتحان",
  Yes: "آره",
  Applicant: "متقاضی اصلی",
  Mother: "مادر",
  Father: "پدر",
  Brothers: "برادران",
  Sisters: "خواهران",
  Children: "فرزندان",
  Education: "تحصیلات",
  Relations: "روابط",
  Languages: "زبان ها",
  Experience: "تجربه",
  Activities: "فعالیت ها",
  Addresses: "آدرس ها",
  Travels: "مسافرت ها",
  Passports: "گذرنامه ها",
  OtherInformation: "سایر توضیحات",
  DateofDeath: "تاریخ وفات",
  ApplyForVisaCanadaBefore: "آیا شما یا یکی از اعضای خانواده تان تا به حال برای ویزای کانادا درخواست داده اید؟ (توریستی، اقامتی، کاری، آموزشی و ...)؟",
  VisaCanadaRejectedBefore: "آیا تاکنون درخواست ویزا برای کانادا یا کشور دیگری برای شما یا یکی از اعضای خانواده رد شده است؟",
  ReportedExperience: "آیا تا به حال شما یا یکی از اعضای خانواده تان از کانادا یا هر کشور دیگری اخراج شده اید؟",
  ModifiedDate: "تاریخ اصلاح",
  SaveChanges: "ذخیره تغییرات",
  OveralExamScore: "نمره نهایی",
  ExpireDate: "تاریخ انقضا",
  SelectYourLevel: "سطح خود را انتخاب کنید",
  DidYouHaveExam: "آیا امتحان داشتید؟",
  WitchExam: "آزمون را انتخاب کنید",
  SelectLanguage: "زبان را انتخاب کنید",
  AsylumApplied: "آیا شما یا یکی از اعضای خانواده تان تا به حال در کانادا یا هر کشور دیگری درخواست پناهندگی داده اید؟",
  ArrestedBefore: "آیا شما یا یکی از اعضای خانواده تان تا به حال مرتکب جرمی شده اید یا دستگیر شده اید؟",
  HealthCareBefore: "علاوه بر مصرف دارو، آیا شما یا هر یک از اعضای خانواده تان در زمانی که در کانادا هستید به کمک ارائه دهندگان مراقبت های بهداشتی نیاز دارید؟",
  StayLongerThanVisa: "آیا شما یا یکی از اعضای خانواده تجربه اقامت بیشتر از مدت اعتبار ویزای خود در کانادا یا کشور دیگری دارید؟",
  TerroristHistory: "آیا شما یا یکی از اعضای خانواده تان سابقه همکاری با گروه های سیاسی یا گروه های تروریستی و غیره را دارید؟",
  SecurityProblems: "لطفاً در صورتی که شما یا هر یک از اعضای خانواده تان سابقه قصور، مشکلات امنیتی یا اقدامات قبلی مرتبط با ویزا از کانادا یا هر کشور دیگری دارید، به طور کامل توضیح دهید.",
  No: "خیر",
  Expert: "کارشناس",
  VeryGood: "خیلی خوب",
  Good: "خوب",
  Competent: "صلاحیت دار",
  Modest: "فروتن",
  Limited: "محدود",
  None: "هیچ یک",
  IELTSGeneral: "آیلتس جنرال",
  IELTSAcademic: "آیلتس آکادمیک",
  CELPIPG: "CELPIP-G",
  TEF: "TEF",
  CELPIP: "CELPIP",
  Gender: "جنسیت",
  FirstName: "نام",
  LastName: "نام خانوادگی",
  FirstNameNativeLanguage: "نام (زبان مادری)",
  LastNameNativeLanguage: "نام خانوادگی (زبان مادری)",
  FirstNameEnglish: "نام (انگلیسی)",
  LastNameEnglish: "نام خانوادگی (انگلیسی)",
  DateofBirth: "تاریخ تولد",
  Height: "قد",
  EyeColor: "رنگ چشم",
  CityofBirth: "شهر تولد",
  CountryofBirth: "کشور محل تولد",
  DeathDate: "تاریخ وفات",
  CityofDeath: "شهر محل وفات",
  CountryofDeath: "کشور محل وفات",
  PostalCode: "کد پستی",
  JobTitle: "عنوان شغلی",
  Company: "شرکت",
  Email: "پست الکترونیک",
  MaritalStatus: "وضعیت تأهل",
  ChildNumber: "تعداد فرزند",
  DateofMarriage: "تاریخ ازدواج",
  DateofDivorce: "تاریخ طلاق",
  Address: "نشانی",
  NetWorth: "ارزش خالص",
  EducationLevel: "سطح تحصیلات",
  EducationMajor: "رشته تحصیلی",
  MoreAboutEducation: "بیشتر درباره دوره تحصیلی",
  WorkExperince: "تجربه کاری",
  WorkType: "نوع کار",
  MoreAboutWork: "اطلاعات بیشتر درباره کار",
  PleaseExplainAboutYourEducationHistory: "لطفا در مورد سوابق تحصیلی خود توضیح دهید",
  PleaseExplainAboutYourJobHistory: "لطفا در مورد سابقه شغلی خود توضیح دهید",
  General: "عمومی",
  Profile: "مشخصات",
  AssessmentForm: "فرم ارزیابی",
  SocialLinks: "پیوندهای اجتماعی",
  ChangePassword: "رمز عبور را تغییر دهید",
  AccountSettings: "تنظیمات حساب",
  Account: "حساب",
  ClientsEvaluated: "مشتریان ارزیابی شدند",
  ImmigrationCases: "پرونده های مهاجرت",
  TotalPosts: "مجموع پست ها",
  About: "درباره",
  LiveAt: "زنده در &nbsp",
  YouAreAssessed: "شما را ارزیابی خواهد کرد",
  AssessingYou: "ارزیابی شما",
  AssessMe: "مرا ارزیابی کن",
  HasAccessDocuments: "به اسناد شما دسترسی دارد",
  DisconnectAccess: "دسترسی را قطع کنید",
  DocumentAccess: "دسترسی به سند",
  Password: "کلمه عبور",
  App: "برنامه",
  user: "کاربر",
  List: "فهرست کنید",
  Edit: "ویرایش کنید",
  Shop: "خرید کنید",
  Blog: "وبلاگ",
  Mail: "ایمیل",
  Chat: "چت کنید",
  Cards: "کارت ها",
  Posts: "نوشته ها",
  Create: "ايجاد كردن",
  Banking: "بانکداری",
  Booking: "رزرو",
  Product: "تولید - محصول",
  Invoice: "صورتحساب",
  Details: "جزئیات",
  Checkout: "وارسی",
  Calendar: "تقویم",
  Analytics: "تجزیه و تحلیل",
  Ecommerce: "تجارت الکترونیک",
  Management: "مدیریت",
  Menu: "منو",
  Item_disabled: "مورد غیرفعال شد",
  Item_label: "برچسب مورد",
  Item_caption: "عنوان مورد",
  Other_cases: "موارد دیگر",
  Item_by_roles: "مورد بر اساس نقش",
  Only_admin_can_see_this_item: "فقط مدیر می تواند این مورد را ببیند",
  TotalElementarySchool: "مجموع سالهای دبستان",
  TotalMiddleSchool: "مجموع سالهای تحصیل در دوره راهنمایی",
  TotalHighSchool: "مجموع سالهای تحصیل در دبیرستان",
  TotalPreUniversity: "مجموع سالهای آموزش پیش دانشگاهی",
  TotalAssociate: "مجموع سنوات تحصیلی مقطع کاردانی",
  TotalUndergraduate: "مجموع سالهای تحصیل در مقطع کارشناسی",
  TotalMaster: "مجموع سالهای تحصیل در مقطع کارشناسی ارشد",
  TotalDoctoral: "مجموع سالهای تحصیل دکتری",
  TotalProfessional: "مجموع سنوات تحصیلی فنی و حرفه ای",
  Organization: "نام موسسه آموزشی",
  Degree: "مدرک تحصیلی",
  Major: "رشته تحصیلی",
  SelectType: "انتخاب نوع",
  StartDate: "تاریخ شروع",
  EndDate: "تاریخ پایان",
  City: "شهر",
  Country: "کشور",
  Relation: "رابطه",
  CityofResidence: "شهر محل زندگی",
  DidYouHaveExam: "آیا امتحان داشتید؟",
  ProvinceofResidence: "استان محل زندگی",
  ActivityType: "نوع فعالیت",
  ActivityLocation: "نام محل فعالیت",
  License: "آیا مدرکی در خصوص این فعالیت دریافت کرده اید؟ نام ببرید.",
  MoreInformation: "اطلاعات بیشتر",
  PassportNumber: "شماره گذرنامه",
  IssueDate: "تاریخ صدور",
  ExpiryDate: "تاریخ انقضا",
  DayPerWeek: "روز در هفته",
  HourPerDay: "ساعت در روز",
  CompanyPhone: "تلفن شرکت",
  CEOName: "نام مدیر عامل",
  CEOPhoneNumber: "شماره تلفن مدیر عامل",
  YourManagerName: "نام مدیر شما",
  YourManagerTitle: "عنوان مدیر شما",
  YourManagerPhoneNumber: "شماره تلفن مدیر شما",
  CompanyPostalCode: "کد پستی شرکت",
  // --------------------------------------

  ActivityLocationHelper: "لطفا نام شرکت، کارفرما، محل تحصیل، موسسه و یا هر نوع محل فعالیت مرتبط را وارد نمایید",
  FullTime: "تمام وقت",
  PartTime: "پاره وقت",
  Citizen: "شهروند",
  PermanentResidence: "دارای اقامت دائم",
  TemporaryResidence: "ویزای موقت",
  StatusinCanada: "وضعیت اقامت",
  Spouse: "همسر",
  Background: "سوابق",
  Documents: "مدارک",
  Questioner: "پرسشنامه",
  Personal: "شخصی",
  PersonalPhoto: "عکس پرسنلی",
  InformationAboutPersonalPhoto: "توضیحات کامل درباره عکس پرسنلی",
  UploadFile: "آپلود فایل",
  PrintTime: "زمان چاپ",
  TranslationDateIfTranslated: "تاریخ ترجمه (اگر ترجمه شده)",
  NationalID: "شناسنامه",
  MilitaryServiceLicense: "کارت پایان خدمت",
  PhotocopyMarriageCertificate: "تصویر سند ازدواج",
  IDCard: "کارت ملی",
  PhotocopyDivorceDocuments: "تصویر طلاق نامه",
  Consultants: "مشاورین",
  MyAccount: "حساب کاربری",
  Management: "مدیریت حساب",
  consultant: "مشاور",
  applicant: "متقاضی",
  ShareWhatThinkingAbout: "نظر شما درباره",
  Post: "ارسال",
  Logout: "خروج",
  Home: "صفحه نخست",
  Beta: "نسخه بتا",
  SignUp: "ثبت نام",
  Dashboard: "داشبورد",
  Pages: "صفحات",
  Other: "سایر",
  AboutUs: "درباره ما",
  ContactUs: "تماس با ما",
  Pricing: "قیمت ها",
  Login: "ورود",
  Register: "ثبت نام",
  ResetPassword: "تغییر رمز عبور",
  WriteComment: "نظر شما در این باره ...",
  Authentication: "احراز هویت",
  SortBy: "نمایش براساس",
  Name: "نام",
  Applicants: "متقاضیان",
  Immigrationfromhereto: "آغاز مهاجرت از اینجا تا",
  Canada: "کانادا",
  BetterProbroadimmigrationplatform: "BetterPro یک پلت فرم گسترده مهاجرتی است که به مهاجران و مشاوران اجازه می دهد یکدیگر را پیدا کنند و هوشمندانه در ارتباط باشند.",
  GetStarted: "شروع کنید",
  HowBetterProHelpYou: "BetterPro چگونه به شما کمک می کند؟",
  ServicesForConsultants: "سرویسهای مخصوص مشاورین",
  Questionnaire: "پرسشنامه",
  CollectInformationAboutClients: "اطلاعات مشتریان مانند اطلاعات شخصی، کار، تحصیلات و غیره را جمع آوری کنید و فرم های مهاجرت را با آن اطلاعات تکمیل کنید.",
  CollectingDocuments: "جمع آوری اسناد و مدارک",
  GatherDocumentsfromApplicants: "مدارک متقاضیان را به صورت دسته بندی شده بر اساس نیازهای هر مورد مهاجرت جمع آوری کنید.",
  SafeCommunication: "ارتباطات ایمن",
  ConsultantsApplicantsCommunicate: "مشاوران مهاجرت و متقاضیان می توانند از طریق BetterPro در تمام مراحل فرآیند مهاجرت (از ارزیابی اولیه تا اخذ ویزا) ارتباط برقرار کنند.",
  ProfilePage: "صفحه پروفایل",
  HavinguptodateProfiles: "داشتن پروفایل های به روز به زبان های مختلف به شما کمک می کند مشتریان بیشتری جذب کنید",
  PlansCustomized: `برنامه هایی که می توانند سفارشی شوند`,
  ToMeetYourNeeds: "برای رفع نیازهای شرکت شما",
  MakeModernOnline: "با انتخاب یک طرح، کسب و کار آنلاین مدرن خود را به موفقیت تبدیل کنید",
  PlusTaxes: "* به علاوه مالیات ",
  mo: "/در ماه",
  POPULAR: "محبوب",
  Basic: "پایه ای",
  ThirtyDaysTrial: "30 روز آزمایشی / بدون نیاز به کارت اعتباری",
  SixtyDaysTrial: "60 روز آزمایشی / بدون نیاز به کارت اعتباری",
  NinetyDaysTrial: "90 روز آزمایشی / بدون نیاز به کارت اعتباری",
  MultilanguageProfile: "پروفایل چند زبانه",
  Blogging: "وبلاگینگ",
  AccessToLeads: "دسترسی به سرنخ ها",
  ComminicateWithClients: "ارتباط با مشتریان",
  FullSupport: "پشتیبانی کامل",
  Starter: "راه انداز",
  Premium: "پریمیوم",
  ChoosePremium: "انتخاب",
  ChooseStarter: "انتخاب",
  ChooseBasic: "انتخاب",
  GetStartedWith: "شروع کنید و",
  BetterProPlatformToday: "امروز به BetterPro بپیوندید",
  WhereFindUs: "کجا ما را پیدا کنید؟",
  FeelFreeContactUs: "در صورت تمایل با ما تماس بگیرید.",
  WeGladHearFromYou: "از شنیدن نظر شما خوشحال خواهیم شد.",
  ToShareYourComment: "برای به اشتراک گذاشتن نظر خود در مورد",
  PleaseSignup: "لطفا ثبت نام کنید",
  IAmConsultant: "مشاور مهاجرت",
  IAmImmigrate: "متقاضی مهاجرت",
  SelectBestOption: "انتخاب بهترین گزینه",
  AlreadyHaveAccount: "از قبل یک حساب دارید؟",
  BroadImmigrationPlatformBetterPro: "سکوی مهاجرت به کانادا با BetterPro",
  GetStartedFree: "شروع به کار کاملا رایگان.",
  NoCreditNeeded: "بدون نیاز به کارت اعتباری.",
  DontHaveAccount: "حساب کاربری ندارید؟",
  EnterDetails: "جزئیات خود را در زیر وارد کنید.",
  WelcomeBack: "سلام، خوش آمدید",
  RememberMe: "به خاطر بسپار",
  ForgotPassword: "رمز عبور را فراموش کرده اید؟",

  FieldofStudy: "رشته تحصیلی",
  TypeofWork: "نوع شفل",
  AnnulledMarriage: "ازدواج فسخ شده",
  CommonLaw: "شریک زندگی",
  DivorcedSeparated: "جدا شده",
  LegallySeparated: "قانونی جدا شده",
  Married: "متاهل",
  NeverMarriedSingle: "هرگز ازدواج نکرده / مجرد",
  Widowed: "بیوه",
  RegisterSaveInformation: "برای ذخیره اطلاعات و دریافت پیام های مشاور ثبت نام کنید",
  UserName: "User Name",
  BlogPosts: "Blog Posts",
  NotProfileLanguage: "Consultant does not have a profile for this language. Please select another language.",
  Services: "Services",
  ContactInfo: "Contact Info (Please let the consultant know how best to contact you)",
  PhoneNumber: "شماره تلفن",
  GoogleSanctions: "اگر کشور شما مشمول تحریم های گوگل است، باید از VPN برای ورود یا ثبت نام استفاده کنید",
};

export default fa;
